import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
const AddCircleOutlineIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(SvgIcon, { ...props, ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "34.02", height: "34.02", viewBox: "0 0 34.02 34.02", children: /* @__PURE__ */ jsxs("g", { "data-name": "Group 13122", children: [
    /* @__PURE__ */ jsxs("g", { "data-name": "Path 14724", fill: "none", children: [
      /* @__PURE__ */ jsx("path", { d: "M17.01 0A17.01 17.01 0 1 1 0 17.01 17.01 17.01 0 0 1 17.01 0z", stroke: "none" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.01 2.1c-3.983 0-7.727 1.55-10.543 4.367A14.812 14.812 0 0 0 2.1 17.01c0 3.982 1.55 7.726 4.367 10.543A14.812 14.812 0 0 0 17.01 31.92c3.982 0 7.726-1.551 10.543-4.367A14.812 14.812 0 0 0 31.92 17.01c0-3.983-1.551-7.727-4.367-10.543A14.812 14.812 0 0 0 17.01 2.1m0-2.1c9.394 0 17.01 7.616 17.01 17.01 0 9.394-7.616 17.01-17.01 17.01C7.616 34.02 0 26.404 0 17.01 0 7.616 7.616 0 17.01 0z",
          fill: "currentColor",
          stroke: "none"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("g", { "data-name": "Group 9009", children: /* @__PURE__ */ jsxs("g", { "data-name": "Group 9008", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          "data-name": "Line 112",
          transform: "translate(9.235 16.934)",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "2.1px",
          fill: "none",
          d: "M0 0h15.701"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          "data-name": "Line 113",
          transform: "translate(17.086 9.083)",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "2.1px",
          fill: "none",
          d: "M0 0v15.701"
        }
      )
    ] }) })
  ] }) }) });
});
export {
  AddCircleOutlineIcon
};
//# sourceMappingURL=AddCircleOutlineIcon.js.map
